var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.2704,
    height: 31,
    rx: 14.6352,
    fill: "#248493"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5344 10.9924C18.3543 10.8924 18.1563 10.8287 17.9516 10.8052C17.747 10.7817 17.5397 10.7987 17.3416 10.8552C17.1435 10.9118 16.9585 11.0069 16.7972 11.135C16.6358 11.2631 16.5013 11.4217 16.4013 11.6018L13.4894 16.842L11.823 15.1755C11.6783 15.0257 11.5052 14.9062 11.3139 14.824C11.1225 14.7418 10.9167 14.6985 10.7084 14.6967C10.5002 14.6949 10.2936 14.7346 10.1009 14.8135C9.90812 14.8923 9.733 15.0088 9.58573 15.1561C9.43847 15.3033 9.322 15.4784 9.24314 15.6712C9.16428 15.864 9.12459 16.0705 9.1264 16.2788C9.12821 16.487 9.17148 16.6928 9.25368 16.8842C9.33588 17.0755 9.45537 17.2486 9.60517 17.3933L12.7421 20.5302C13.0385 20.8274 13.4385 20.9905 13.851 20.9905L14.0682 20.9749C14.3086 20.9412 14.5379 20.8523 14.7381 20.7149C14.9383 20.5776 15.1039 20.3957 15.2218 20.1836L19.1429 13.1255C19.243 12.9455 19.3067 12.7475 19.3303 12.5429C19.3539 12.3383 19.337 12.131 19.2805 11.9329C19.2239 11.7349 19.129 11.5499 19.001 11.3885C18.8729 11.2271 18.7144 11.0925 18.5344 10.9924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTic);
export default __webpack_public_path__ + "static/media/green-tic.fa61be8fe301864e549a3971b5a8d220.svg";
export { ForwardRef as ReactComponent };